import { TermsOfUse } from '../../components/pages/general/policy/tou/';

export default function Tou({ }) {
    return (
        <div>
            <TermsOfUse />
        </div>
    )
}